import apiClient from "../apiClient";

const updateMetrics = (data) => apiClient.post("/admin/edit-metrics", data);
const getMetrics = (outletId) => apiClient.get(`/admin/get-metrics?outlet_id=${outletId}`);
const getAllMetrics = () => apiClient.get("/admin/get-all-metrics");

export default {
  updateMetrics,
  getMetrics,
  getAllMetrics,
};
